import React from 'react';

const Tooltip = ({ tooltip, className, children, ...rest }) => (
  <span className={className} data-tooltip={tooltip} {...rest}>
    {children}
  </span>
);

export default Tooltip;



// WEBPACK FOOTER //
// ./app/javascript/common/components/Tooltip.js